export const INBOX_TEXT = {
  INBOX_MAIN_CONTAINER: {
    LABELS: {
      CENTER_TITLE: 'Select a conversation to view details',
      CENTER_SECTION: 'Conversation information will appear once selected',
    },
    TOAST_MESSAGES_ERRORS: {
      LOAD_USERS: 'Failed to load users',
    },
  },

  INBOX_RIGHT_CONTAINER: {
    LABELS: {
      STATUS: 'Status',
      STAGE: 'Stage',
      DETAILS: 'Details',
      SOURCE: 'Source',
      UTM_PARAMETERS: 'Utm parameters',
      COOKIE_TRACKING_HISTORY: 'Cookie tracking history',
      TASKS: 'Tasks',
      NOTES: 'Notes',
      NO_TASKS: 'No tasks',
      SUBTEXT: 'No task list is present',
      DELETE: 'Delete ',
      ADD: 'Add Task',
      EDIT: 'Edit Task',
      OPEN: 'openTask',
    },
    TOAST_MESSAGES_SUCCESS: {
      UPDATE_DETAILS: ' updated successfully',
    },
    TOAST_MESSAGES_ERRORS: {
      UPDATE_DETAILS: 'Failed to update ',
      LOAD_DEATILS: 'Unable to load lead details or contact stats',
    },
  },

  INBOX_DETAIL_HEADER: {
    LABELS: {
      CREATE_CONTACT: 'Create Contact',
      VIEW_CONTACT: 'View Contact',
      VIEW_CONTACT_DETAIL: 'View Contact Detail',
      GIA: 'Gia',
    },
    PLACEHOLDERS: {
      ASSIGN: 'Unassigned',
    },
    TOOLTIPS: {
      GIA_ENABLED: 'Gia is responding to this contact. Turn off to pause.',
      GIA_DISABLED:
        'Gia is paused for this contact and will not send automated responses.',
    },
    TOAST_MESSAGES_SUCCESS: {
      ASSIGN: 'This conversation is now assigned to',
      UNASSIGN: 'This conversation is now unassigned',
      MARK_AS_COMPLETE:
        'The conversation has been successfully marked as completed',
      MARK_AS_REOPEN: 'The conversation has been reopened and is now active.',
      GIA_ENABLED: 'Gia will now respond to this contact',
      GIA_DISABLED: 'Gia has been paused for this contact',
    },
    TOAST_MESSAGES_ERRORS: {
      ASSIGN: 'Failed to assign user',
      MARK_AS_COMPLETE: 'Unable to complete the conversation. Please try again',
      MARK_AS_REOPEN: 'Unable to reopen the conversation. Please try again.',
      GIA_ENABLED: 'Unable to enable Gia for this contact. Please try again.',
      GIA_DISABLED: 'Unable to pause Gia for this contact. Please try again.',
    },
  },

  INBOX_DETAILS_NOTES: {
    LABELS: {
      LOAD_COMMENTS: 'Loading Notes...',
      NO_NOTES: 'No Notes',
      SUBTEXT: 'No notes have been submitted yet.',
      ADD: 'Add Note',
      EDIT: 'Edit Note',
    },
  },
};
